import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { getDeviceSession, evaluateFlag } from '@datavant/idsb-portal-sdk/server';
import dynamic from 'next/dynamic';

const Page = ({ shouldRedirect }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const Component = dynamic(() => import('@/components/LandingPage'), {
        ssr: false,
    });

    return <Component shouldRedirect={shouldRedirect} />;
};

export const getServerSideProps: GetServerSideProps<{ shouldRedirect: boolean }> = async ({ req, res }) => {
    try {
        const deviceSession = await getDeviceSession(req, res);
        console.info({ deviceSession });

        const shouldRedirect =
            typeof deviceSession.shouldRedirectToRMStandard !== 'undefined'
                ? deviceSession.shouldRedirectToRMStandard
                : await evaluateFlag('request-manager-standard-as-default', null, req, res, false);

        console.info({ shouldRedirect });

        if (shouldRedirect) {
            console.info('updating device session to redirect user', { deviceSession });

            deviceSession.shouldRedirectToRMStandard = true;
            await deviceSession.save();
        }

        return {
            props: {
                shouldRedirect,
            },
        };
    } catch {
        return {
            props: {
                shouldRedirect: false,
            },
        };
    }
};

export default Page;
